// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.router-link-exact-active.c-active.c-sidebar-nav-link {\n  background-color: #59718d;\n}\n.c-sidebar-nav-dropdown-toggle {\n  font-weight: bold;\n}\n.c-sidebar-nav-dropdown-items {\n  /*margin-left:5px;*/\n  opacity: 0.6;\n}\n\n/*.c-sidebar{\n  display:none;\n}*/\n", ""]);
// Exports
module.exports = exports;
